export const getIsEulasAccepted = state => {
    const eula = state.get('eula').toJS();
    return eula.affiliate.accepted && eula.conduct.accepted;
};
export const getIsEulasLoading = state => {
    const eula = state.get('eula').toJS();

    return eula.affiliateLoading || eula.conductLoading;
};
export const getAffiliateAgreement = state => state.get('eula').toJS().affiliate;
export const getConductAgreement = state => state.get('eula').toJS().conduct;
